export default __webpack_public_path__ + "assets/images/dancer@2x.e58f861809e008804d24197aa8316c54.png";